import { alphaColor } from '_/space-management/constants/theme';
import {
  getSpaceTypeColor,
  SpaceType,
} from '_/space-management/services/models/enums/space-type.enum';
import { colors } from '_/space-management/constants/theme';
import { StyleSheet } from 'react-native';

const styles = (spaceType?: SpaceType, isAvailable: boolean = true) =>
  StyleSheet.create({
    slot: {
      flex: 1,
      minHeight: 56,
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      borderWidth: 1,
      borderColor: isAvailable ? alphaColor(getSpaceTypeColor(spaceType), 0.3) : colors.disabledGrey,
      backgroundColor: isAvailable ? 'transparent' : colors.lightGrey,
      borderRadius: 6,
      marginVertical: 4,
      marginHorizontal: 8,
    },
    slotName: {
      padding: 1,
      textAlign: 'left',
      color: isAvailable ? colors.black : colors.grey,
      textDecorationLine: isAvailable ? 'none' : 'line-through'
    },
  });

export default styles;
